export default __webpack_public_path__ + "static/media/account-set-up.e63973cf.svg";